import { render, staticRenderFns } from "./MFenxiao.vue?vue&type=template&id=3f7c225a&scoped=true&"
import script from "./MFenxiao.vue?vue&type=script&lang=js&"
export * from "./MFenxiao.vue?vue&type=script&lang=js&"
import style0 from "./MFenxiao.vue?vue&type=style&index=0&id=3f7c225a&lang=scss&scoped=true&"
import style1 from "./MFenxiao.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7c225a",
  null
  
)

export default component.exports